<script setup lang="ts">
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';

    import BaseLayout from '@/layouts/Base.vue';

    const route = useRoute();

    const layout = computed(() => {
        return route.meta.layout || BaseLayout;
    });
</script>

<template>
    <div id="app">
        <NotificationSnack />
        <component :is="layout">
            <RouterView />
        </component>
    </div>
</template>
